/**
 * 状态管理
 */

/**
 * 创建table数据仓库对象
 * @param {Object} table table对象
 * @param {Object} initialState 自定义参数对象
 * @constructor
 */
// const EditTableStore = function(table, initialState = {}) {
const EditTableStore = function(table) {
  if (!table) {
    throw new Error("Table is required");
  }

  this.table = table;
  this.states = {};
};

export default EditTableStore;
